/**
 * @author Milton Filho
 */
import { combineEpics } from 'redux-observable';
import { syncOnReconnect$ } from './syncOnReconnect$';
import { resolveBookingConflict$ } from './resolveBookingConflict$';
import { RootEpic } from 'types/types';

const epics: RootEpic = combineEpics(syncOnReconnect$, resolveBookingConflict$);

export default epics;
